/* Quote emails and address: brand the email, fix the product links and the address of a quote request.
   Written by shopify-notifications/sa-quote/build_sa_quote.py in the consulting repo. Do not edit by hand.

   The quote app has no brand variable. When a quote is sent, this puts one finished block (the
   site's logo bar, heading, copy, support address, button and sign-off, every style inline) into
   the form's "Email Theme Selector" field, which the email templates print. The customer's message
   is left as written. It also points the quote's product links at the site the customer is on, and
   copies the State/Province field into the quote's address (official name and code for the United
   States and Canada), which the Fishbowl import needs, and the shipping name and phone into the
   customer when Contact Information does not ask for them. Nothing on the page is changed. */
(function () {
  var BRANDS = {
    "volanobiz.com": {
      "name": "Volanobiz",
      "logo": "https://cdn.shopify.com/s/files/1/0820/2711/8849/files/email-logo-volanobiz.png?v=1788634241&width=260",
      "w": 130,
      "bg": "#000000",
      "accent": "#e51e25",
      "accentText": "#ffffff",
      "support": "info@volanobiz.com"
    },
    "imperia-parts.com": {
      "name": "Imperia Parts",
      "logo": "https://cdn.shopify.com/s/files/1/0820/2711/8849/files/email-logo-imperia-parts.png?v=1788634241&width=440",
      "w": 220,
      "bg": "#cecece",
      "accent": "#e51e25",
      "accentText": "#ffffff",
      "support": "support@imperia-parts.com"
    },
    "pastaextruderdies.com": {
      "name": "Pasta Extruder Dies",
      "logo": "https://cdn.shopify.com/s/files/1/0820/2711/8849/files/email-logo-pastaextruderdies.png?v=1788634241&width=220",
      "w": 110,
      "bg": "#000000",
      "accent": "#9b8564",
      "accentText": "#ffffff",
      "support": "support@pastaextruderdies.com"
    },
    "pastabiz.com": {
      "name": "Pastabiz",
      "logo": "https://cdn.shopify.com/s/files/1/0820/2711/8849/files/email-logo-pastabiz.png?v=1788634241&width=240",
      "w": 120,
      "bg": "#000000",
      "accent": "#f9c941",
      "accentText": "#111111",
      "support": "support@pastabiz.com"
    },
    "emiliomiti.com": {
      "name": "EmilioMiti",
      "logo": "https://cdn.shopify.com/s/files/1/0820/2711/8849/files/email-logo-emiliomiti.png?v=1788634241&width=280",
      "w": 140,
      "bg": "#000000",
      "accent": "#00a651",
      "accentText": "#ffffff",
      "support": "support@emiliomiti.com"
    }
  };
  var BLOCK = "<!-- Quote request from [[NAME]] ([[HOST]]). Email branding added by the storefront. --><div style=\"background:[[BG]];padding:18px 24px;text-align:center;\"><a href=\"[[SITE]]\" style=\"text-decoration:none;\"><img src=\"[[LOGO]]\" width=\"[[LOGO_W]]\" alt=\"[[NAME]]\" style=\"display:inline-block;width:[[LOGO_W]]px;height:auto;border:0;\"><\/a><\/div><div style=\"padding:32px 40px 0 40px;\"><h1 style=\"margin:0 0 4px 0;font-family:Montserrat,Helvetica,Arial,sans-serif;font-size:22px;line-height:30px;font-weight:700;letter-spacing:.02em;text-transform:uppercase;color:#111111;\">Thank you for your quote request<\/h1><p style=\"margin:0;font-family:Montserrat,Helvetica,Arial,sans-serif;font-size:14px;line-height:22px;color:#555555;\">[[NAME]]<\/p><\/div><div style=\"padding:16px 40px 20px 40px;\"><div style=\"height:1px;line-height:1px;font-size:1px;background:#e5e5e5;\">&nbsp;<\/div><\/div><div style=\"padding:0 40px;\"><p style=\"margin:0 0 16px 0;font-family:Montserrat,Helvetica,Arial,sans-serif;font-size:14px;line-height:22px;color:#111111;\">Hello[[HELLO]]<\/p><p style=\"margin:0 0 16px 0;font-family:Montserrat,Helvetica,Arial,sans-serif;font-size:14px;line-height:22px;color:#111111;\">Thank you for your quote request from [[NAME]]. We have received it and you can expect our proposal within the next 48 hours (Monday to Friday). We will email you as soon as it is ready.<\/p><p style=\"margin:0 0 24px 0;font-family:Montserrat,Helvetica,Arial,sans-serif;font-size:14px;line-height:22px;color:#111111;\">If you have any questions about your quote request please contact us at <a href=\"mailto:[[SUPPORT]]\" style=\"color:#111111;text-decoration:underline;\">[[SUPPORT]]<\/a> or call us at +1-415-621-1909 Monday - Friday, 8am - 5pm PST.<\/p><table role=\"presentation\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\" style=\"margin:0 0 24px 0;\"><tr><td align=\"center\" bgcolor=\"[[ACCENT]]\" style=\"background:[[ACCENT]];\"><a href=\"[[SITE]]/pages/quotes-history\" style=\"display:inline-block;padding:14px 28px;font-family:Montserrat,Helvetica,Arial,sans-serif;font-size:13px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:[[ACCENT_TEXT]];text-decoration:none;\">View your quote requests<\/a><\/td><\/tr><\/table><p style=\"margin:0 0 24px 0;font-family:Montserrat,Helvetica,Arial,sans-serif;font-size:14px;line-height:22px;color:#111111;\">Thank you,<br><strong>[[NAME]]<\/strong><\/p><\/div>";
  var MARK = "<!-- Quote request from ";
  var F_BRAND = 'additional_data[' + "text__1791307860172" + ']';
  var F_MESSAGE = 'additional_data[' + "project_detail" + ']';
  var F_STATE = 'additional_data[' + "text__1791307767657" + ']';
  var REGIONS = {"US":[["Alabama","AL"],["Alaska","AK"],["American Samoa","AS"],["Arizona","AZ"],["Arkansas","AR"],["California","CA"],["Colorado","CO"],["Connecticut","CT"],["Delaware","DE"],["District of Columbia","DC"],["Federated States of Micronesia","FM"],["Florida","FL"],["Georgia","GA"],["Guam","GU"],["Hawaii","HI"],["Idaho","ID"],["Illinois","IL"],["Indiana","IN"],["Iowa","IA"],["Kansas","KS"],["Kentucky","KY"],["Louisiana","LA"],["Maine","ME"],["Marshall Islands","MH"],["Maryland","MD"],["Massachusetts","MA"],["Michigan","MI"],["Minnesota","MN"],["Mississippi","MS"],["Missouri","MO"],["Montana","MT"],["Nebraska","NE"],["Nevada","NV"],["New Hampshire","NH"],["New Jersey","NJ"],["New Mexico","NM"],["New York","NY"],["North Carolina","NC"],["North Dakota","ND"],["Northern Mariana Islands","MP"],["Ohio","OH"],["Oklahoma","OK"],["Oregon","OR"],["Palau","PW"],["Pennsylvania","PA"],["Puerto Rico","PR"],["Rhode Island","RI"],["South Carolina","SC"],["South Dakota","SD"],["Tennessee","TN"],["Texas","TX"],["Utah","UT"],["Vermont","VT"],["U.S. Virgin Islands","VI"],["Virginia","VA"],["Washington","WA"],["West Virginia","WV"],["Wisconsin","WI"],["Wyoming","WY"],["Armed Forces Americas","AA"],["Armed Forces Europe","AE"],["Armed Forces Pacific","AP"]],"CA":[["Alberta","AB"],["British Columbia","BC"],["Manitoba","MB"],["New Brunswick","NB"],["Newfoundland and Labrador","NL"],["Northwest Territories","NT"],["Nova Scotia","NS"],["Nunavut","NU"],["Ontario","ON"],["Prince Edward Island","PE"],["Quebec","QC"],["Saskatchewan","SK"],["Yukon","YT"]]};
  var host = location.hostname;
  var bare = host.replace(/^(dev|stage|www)\./, '');
  var known = !!BRANDS[bare];
  var key = known ? bare : "emiliomiti.com";
  var b = BRANDS[key];
  var siteHost = known ? host.replace(/^www\./, '') : key;
  var esc = function (t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  };
  function block(name) {
    var values = {
      NAME: b.name, HOST: key, SITE: 'https://' + siteHost, LOGO: b.logo, LOGO_W: String(b.w), BG: b.bg,
      ACCENT: b.accent, ACCENT_TEXT: b.accentText, SUPPORT: b.support,
      HELLO: name ? ', ' + esc(name) : ''
    };
    return BLOCK.replace(/\[\[([A-Z_]+)\]\]/g, function (m, k) { return values[k] === undefined ? '' : values[k]; });
  }
  var norm = function (t) { return String(t || '').toLowerCase().replace(/[^a-z]/g, ''); };
  // [name, code] for the typed state or province, or null when the country has no list or nothing matches
  function region(country, typed) {
    var list = REGIONS[String(country || '').toUpperCase()];
    var t = norm(typed);
    if (!list || !t) return null;
    var starts = [];
    for (var i = 0; i < list.length; i++) {
      if (norm(list[i][0]) === t || norm(list[i][1]) === t) return list[i];
      if (t.length >= 3 && norm(list[i][0]).indexOf(t) === 0) starts.push(list[i]);
    }
    return starts.length === 1 ? starts[0] : null;  // "ont" is Ontario; "new" is ambiguous
  }
  function fixAddress(body) {
    if (!body.has('general_info')) return;
    var info = JSON.parse(body.get('general_info'));
    var c = info && info.customer_info;
    var a = c && c.default_address;
    if (!a) return;
    // The form asks for the name and phone once, in the shipping address; the app
    // builds the customer from Contact Information only, so copy them across.
    if (!String(c.first_name || '').trim() && !String(c.last_name || '').trim()) {
      c.first_name = a.first_name || '';
      c.last_name = a.last_name || '';
    }
    if (!String(c.customer_name || '').trim()) c.customer_name = [c.first_name, c.last_name].join(' ').trim();
    if (!String(c.phone || '').trim() && a.phone) c.phone = a.phone;
    var country = a.country_code || a.country || '';
    if (!a.country_code && /^[A-Z]{2}$/.test(country)) a.country_code = country;
    var typed = body.has(F_STATE) ? String(body.get(F_STATE) || '').trim() : '';
    if (typed && !a.province) {
      var r = region(country, typed);
      a.province = r ? r[0] : typed;
      a.province_code = r ? r[1] : '';
      if (r) body.set(F_STATE, r[0]);
    }
    body.set('general_info', JSON.stringify(info));
  }
  function rewrite(body) {
    if (!body || typeof body.forEach !== 'function' || typeof body.set !== 'function') return;
    var keys = [];
    body.forEach(function (v, k) { keys.push(k); });
    keys.forEach(function (k) {
      if (!/^quotes\[\d+\]$/.test(k)) return;
      try {
        var q = JSON.parse(body.get(k));
        if (q && typeof q.product_url === 'string') {
          q.product_url = q.product_url.replace(/^(https?:)?\/\/[^\/]+/, '//' + siteHost);
          body.set(k, JSON.stringify(q));
        }
      } catch (e) {}
    });
    try { fixAddress(body); } catch (e) {}
    if (String(body.get(F_BRAND) || '').indexOf(MARK) === 0) return;
    var name = '';
    try {
      var ci = JSON.parse(body.get('general_info')).customer_info;
      name = (ci.customer_name || '').trim() || [ci.default_address.first_name, ci.default_address.last_name].join(' ').trim();
    } catch (e) {}
    body.set(F_BRAND, block(name));
  }
  function isSubmit(url) { return /\/app\/submit(\?|$)/.test(String(url || '')); }
  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      try {
        if (isSubmit(typeof input === 'string' ? input : input && input.url) && init) rewrite(init.body);
      } catch (e) {}
      return nativeFetch.apply(this, arguments);
    };
  }
  var open = XMLHttpRequest.prototype.open;
  var send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) { this.__quoteUrl = url; return open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (body) {
    try { if (isSubmit(this.__quoteUrl)) rewrite(body); } catch (e) {}
    return send.apply(this, arguments);
  };
})();
